import { createContext, useContext } from 'react';

type PageRenderContextType = {
  paginaID?: string;
  registro?: any;
  setRegistro?: React.Dispatch<React.SetStateAction<any>>
};

export const PageRenderContext = createContext<PageRenderContextType>({
  paginaID: undefined,
  registro: undefined,
  setRegistro: undefined
});


export const usePageRenderContext = () => {
  const context = useContext(PageRenderContext);
  if (!context) {
    throw new Error('usePageRenderContext deve ser usado dentro de PageRenderContext.Provider');
  }
  return context;
};